import styled from '@emotion/styled'
import { Box, TableCell, Table } from '@mui/material'
import { MEDIA, LEGEND_TEXT_COLOR_MAP } from '../../constants'

export const TableCellHead = styled(TableCell)(`
    text-transform: none !important;
    font-weight:600 !important;
    font-size:14px !important;
    line-height:21px !important;
    padding:8px;
    letter-spacing:0 !important;

    &.headingTitle.isEngagement { width: 250px !important; }
    &.positivePercent.isEngagement { display: none; }
    &.neutralPercent.isEngagement { display: none; }
    &.mixedPercent.isEngagement { display: none; }
    &.negativePercent.isEngagement { display: none; }
    &.totalPercent.isEngagement { }
`)

export const TableCellRow = styled(TableCell)(`
    text-transform: none;
    font-weight:400;
    font-size:14px;
    line-height:21px;
    padding:8px;
    letter-spacing:0;

    &.positivePercent.isEngagement { display: none; }
    &.neutralPercent.isEngagement { display: none; }
    &.mixedPercent.isEngagement { display: none; }
    &.negativePercent.isEngagement { display: none; }
    &.totalPercent.isEngagement { }

    &.barWidth { min-width: 120px; width:15%; padding:4px 12px; }
        
    &.Positive { color:${LEGEND_TEXT_COLOR_MAP.Positive}; }
    &.Neutral { color:${LEGEND_TEXT_COLOR_MAP.Natural}; }
    &.Negative { color:${LEGEND_TEXT_COLOR_MAP.Negative}; }
    &.Mixed { color:${LEGEND_TEXT_COLOR_MAP.Mixed}; }
    
    & .barLabel {display:none;}

    @media (max-width: ${MEDIA?.lg2}) {
        &.barWrap .progressBar {display:none;}
        &.barWrap .barLabel {display:block; line-height:20px; height:20px; width: 50px; padding:0 12px; border-radius:4px; text-align: center; color: #fff; font-weight: normal; font-size: 13px; }
    }
`)

export const ProgressBarWrapper = styled(Box)(`
    width: 100%;
    display: flex;
    align-items: center;
    & span { border-radius: 4px; }
    p {font-weight: 400 !important;}
`)

export const TableWrapper = styled(Table)(`
  table-layout:fixed;
  width: 100%;
  border-collapse: separate;

  border: 1px #D2D5DA solid;
  border-radius: 4px;
  & td {
    border: 0;
    border-bottom: 1px #D2D5DA solid;
  }
  & tr:last-of-type td {
    border-bottom: 0 !important;
  }
`)
